import React, { useState } from 'react';
import { connect } from 'react-redux';
import ApiRequestor from '../../api_access/ApiRequestor';
import { IonButton, IonCol, IonIcon, IonRow, IonSpinner, IonText } from '@ionic/react';
import { eye, pencil, trash } from 'ionicons/icons';

import { GetABMConsulta } from '../../store/ABMUsers/ABMConsulta/ABMConsultaActions';

import Modal from '../Modal/Modal';

import './ABMUsers.css';

interface Data {
    client_access_name: string,
    client_access_permissions: string[],
}

interface Props extends StateTypes, dispatchTypes {
    consultaData: Data;
    userCallback: (data: any) => void;
    modifyCallback: (data: any) => void;

}

const ABMConsultaTable: React.FC<Props> = (props): JSX.Element => {

    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalSuccessDelete, setShowModalSuccessDelete] = useState(false)
    const [showSpinner, setShowSpinner] = useState(false)


    const deleteUser = async (username: any) => {
        setShowModalDelete(false);
        setShowSpinner(true)

        const response: any = await ApiRequestor.requestToApi(`/client-access/${username}`, "DELETE", null, "USER");

        if (response && response.status === 200) {
            props.getABMConsulta()
            setShowSpinner(false);
            setShowModalSuccessDelete(true);
        }
    }

    const deleteUserModal = () => {
        setShowModalSuccessDelete(false);
    }

    return (
        <IonRow className="ion-align-items-center ion-justify-content-center ion-justify-content-between ABMUsersRow">
            <IonCol className="ABMUsersCol" sizeLg="2" sizeXs='9'>
                <IonText>
                    {props.consultaData.client_access_name}
                </IonText>
            </IonCol>
            <IonCol className="ABMUsersCol ABMUsersTableMobile-hidden ABMUsersReducedTableMobile-hidden" sizeLg="7" sizeMd="1.7" sizeSm='1'>
                <IonText>
                    {props.consultaData.client_access_permissions.join(", ")}
                </IonText>
            </IonCol>
            <IonCol className="ABMUsersCol ABMUsersTableMobile-hidden ABMUsersReducedTableMobile-hidden" sizeLg="1" sizeMd="1.7" sizeSm='1'>
                <IonButton fill='clear' onClick={() => props.modifyCallback(props.consultaData)} id={props.consultaData.client_access_name + "Users"}>
                    <IonIcon icon={pencil} color="secondary" className="ABMUsersTableButton" />
                </IonButton>
            </IonCol>
            <IonCol className="ABMUsersCol" sizeLg="1" sizeXs='3'>
                <IonButton fill='clear' onClick={() => props.userCallback(props.consultaData.client_access_name)} id={props.consultaData.client_access_name + "Users"}>
                    <IonIcon icon={eye} color="secondary" className="ABMUsersTableButton" />
                </IonButton>
            </IonCol>
            <IonCol className="ABMUsersCol ABMUsersTableMobile-hidden ABMUsersReducedTableMobile-hidden" sizeLg="1" sizeMd="1.7" sizeSm='1'>
                <IonButton type="button" fill="clear" onClick={() => setShowModalDelete(true)} id={props.consultaData.client_access_name + "Eliminar"}>
                    <IonIcon icon={trash} color="danger" className="ABMUsersTableButton" />
                </IonButton>
            </IonCol>


            <Modal
                modalPrincipal={{
                    textPrincipal: `¿Deseas eliminar el usuario ${props.consultaData.client_access_name}?`,
                    isOpen: showModalDelete,
                    onDidDismiss: () => setShowModalDelete(false),
                    onClickCloseModal: () => setShowModalDelete(false),
                    onClick: () => deleteUser(props.consultaData.client_access_name),
                    nameIcon: "personRemove",
                    colorIcon: "danger",
                }}

                modalConfirmation={
                    {
                        textConfirmation: 'Usuario Eliminado con Éxito',
                        onDidDimissConfirmModal: () => deleteUserModal(),
                        isOpenModalConfirm: showModalSuccessDelete,
                        onClickConfirmModal: () => setShowModalSuccessDelete(false),
                    }
                }
            />
            {showSpinner &&
                <IonCol size='12' className="ion-padding">
                    <IonSpinner color="tertiary" name='lines' style={{ position: "fixed", top: "50%", left: "50%" }} />
                </IonCol>
            }
        </IonRow>
    )
}

interface StateTypes {
}

const mapStateProps = (state: StateTypes) => {
    return {
    }
}

interface dispatchTypes {
    getABMConsulta: () => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getABMConsulta: () => dispatch(GetABMConsulta())
    };
}

export default connect(mapStateProps, mapDispatchToProps)(ABMConsultaTable);